import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { JobStatistics } from '../entities';

@Component({
    selector: 'app-statistics-details',
    templateUrl: './statistics-details.component.html',
    styleUrls: ['./statistics-details.component.scss'],
    standalone: false,
})
export class StatisticsDetailsComponent {
    // @ts-ignore TS2564
    @Input() jobStatistics: JobStatistics;
    constructor() {}
}

@NgModule({
    declarations: [StatisticsDetailsComponent],
    imports: [CommonModule],
    exports: [StatisticsDetailsComponent],
})
export class StatisticsDetailsModule {}
